import { MessageSquareText, Quote } from "lucide-react";

export default function ReviewExcerpt({
  review,
  className = "",
  textClassName = "mt-6 font-heading text-xl font-bold leading-snug text-midnight",
  labelClassName = "mt-7 text-xs leading-relaxed text-foreground/60",
  iconClassName = "h-5 w-5 text-tisab",
}) {
  const isExcerpt = review.type === "excerpt";
  const Icon = isExcerpt ? Quote : MessageSquareText;

  return (
    <figure className={className}>
      <Icon className={iconClassName} aria-hidden="true" />
      {isExcerpt ? (
        <blockquote className={textClassName}>“{review.quote}”</blockquote>
      ) : (
        <p className={textClassName}>{review.quote}</p>
      )}
      <figcaption className={labelClassName}>
        {isExcerpt
          ? "Ordagrant utdrag ur ett Reco-omdöme"
          : "Sammanfattning av ett Reco-omdöme"}
      </figcaption>
    </figure>
  );
}
